import { v4 as uuidv4 } from 'uuid';

export function GiftName(props) {
	return {
		componentName: 'GiftName',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		props: {
			linkToProductPage: false,
			...props,
		},
		childrenComponents: [],
	};
}
